import React from "react";
import { useLanguage } from "../../contexts/LanguageContext";
import { t } from "../../i18n";

const PrivacyPage = () => {
    const { lang } = useLanguage();

    const ContentTR = () => (
        <div className="max-w-none space-y-8 text-foreground/80 leading-relaxed">
            <section>
                <p className="text-lg">
                    profinoks.com , profinoks.com.tr , profinoks.net (Profinoks) olarak kişisel verilerinizin güvenliği hususuna azami hassasiyet göstermekteyiz. Kişisel verileriniz 6698 sayılı Kişisel Verilerin Korunması Kanunu (“KVKK”)’na uygun olarak işlenmekte ve muhafaza edilmektedir.
                </p>
            </section>

            <section className="space-y-4">
                <h2 className="text-xl font-bold text-foreground border-l-4 border-primary pl-4 uppercase tracking-wider">1. Kişisel Verilerinizin Ne Şekilde İşlenebileceği</h2>
                <p>
                    6698 sayılı KVKK uyarınca, profinoks.com.tr ile paylaştığınız kişisel verileriniz, tamamen veya kısmen, otomatik olarak veyahut herhangi bir veri kayıt sisteminin parçası olmak kaydıyla otomatik olmayan yollarla elde edilerek, kaydedilerek, depolanarak, değiştirilerek, yeniden düzenlenerek, kısacası veriler üzerinde gerçekleştirilen her türlü işleme konu olarak tarafımızdan işlenebilecektir. KVKK kapsamında veriler üzerinde gerçekleştirilen her türlü işlem “kişisel verilerin işlenmesi” olarak kabul edilmektedir.
                </p>
            </section>

            <section className="space-y-4">
                <h2 className="text-xl font-bold text-foreground border-l-4 border-primary pl-4 uppercase tracking-wider">2. Kişisel Verilerinizin İşlenme Amaçları Ve Hukuki Sebepleri</h2>
                <p>Paylaştığınız kişisel veriler,</p>
                <ul className="list-disc pl-6 space-y-2">
                    <li>Müşterilerimize verdiğimiz hizmetlerin gereklerini, sözleşmenin ve teknolojinin gereklerine uygun şekilde yapabilmek, sunulan ürün ve hizmetlerimizi geliştirebilmek için;</li>
                    <li>Kamu güvenliğine ilişkin hususlarda ve hukuki uyuşmazlıklarda, talep halinde ve mevzuat gereği savcılıklara, mahkemelere ve ilgili kamu görevlilerine bilgi verebilmek için;</li>
                    <li>Üyelerimize geniş kapsamda çeşitli imkânlar sunabilmek veya bu imkânları sunabilecek kişi veya kurumlarla yasal çerçevede paylaşabilmek için;</li>
                    <li>Reklam tercihlerini analiz etmek için,</li>
                </ul>
                <p>6698 sayılı KVKK ve ilgili ikincil düzenlemelere uygun olarak işlenecektir.</p>
            </section>

            <section className="space-y-4">
                <h2 className="text-xl font-bold text-foreground border-l-4 border-primary pl-4 uppercase tracking-wider">3. Kişisel Verilerinizin Aktarılabileceği Üçüncü Kişi Veya Kuruluşlar Hakkında Bilgilendirme</h2>
                <p>
                    Yukarıda belirtilen amaçlarla, profinoks.com , profinoks.com.tr , profinoks.net ile paylaştığınız kişisel verilerinizin aktarılabileceği kişi / kuruluşlar; ana hissedarlarımız, hissedarlarımız, reklam verenler, doğrudan veya dolaylı yurt içi / yurt dışı iştiraklerimiz; sunulan hizmet ile ilgili kişi ve kuruluşlar olmak üzere, faaliyetlerimizi yürütmek üzere ve/veya Veri İşleyen sıfatı ile hizmet aldığımız, iş birliği yaptığımız, program ortağı kuruluşları, yurtiçi / yurtdışı kuruluşlar ve diğer 3. kişiler ve kuruluşlardır.
                </p>
            </section>

            <section className="space-y-4 text-sm bg-gray-50 p-6 rounded-lg border border-black/5">
                <h2 className="text-lg font-bold text-foreground uppercase tracking-wider">4. İletişim ve Başvuru Yöntemi</h2>
                <p>
                    Kişisel Veri Sahipleri, sorularını, görüşlerini veya taleplerini <a href="mailto:info@profinoks.com.tr" className="text-primary hover:underline">info@profinoks.com.tr</a> e-posta adresine yöneltebilirler.
                </p>
            </section>
        </div>
    );

    const ContentEN = () => (
        <div className="max-w-none space-y-8 text-foreground/80 leading-relaxed">
            <section>
                <p className="text-lg">
                    As profinoks.com, profinoks.com.tr, profinoks.net (Profinoks), we show maximum sensitivity to the security of your personal data. Your personal data is processed and stored in accordance with the Law on Protection of Personal Data No. 6698 ("KVKK").
                </p>
            </section>

            <section className="space-y-4">
                <h2 className="text-xl font-bold text-foreground border-l-4 border-primary pl-4 uppercase tracking-wider">1. How Your Personal Data May Be Processed</h2>
                <p>
                    In accordance with KVKK No. 6698, your personal data shared with profinoks.com.tr may be processed by us as subject to any kind of processing performed on the data, by obtaining, recording, storing, changing, rearranging, in short, by being part of any data recording system automatically or manually. Any operation performed on the data within the scope of KVKK is considered "processing of personal data".
                </p>
            </section>

            <section className="space-y-4">
                <h2 className="text-xl font-bold text-foreground border-l-4 border-primary pl-4 uppercase tracking-wider">2. Purposes and Legal Reasons for Processing Your Personal Data</h2>
                <p>Personal data you share,</p>
                <ul className="list-disc pl-6 space-y-2">
                    <li>To fulfill the requirements of the services we provide to our customers in accordance with the requirements of the contract and technology, and to improve our products and services;</li>
                    <li>To provide information to prosecution offices, courts, and relevant public officials in matters related to public safety and legal disputes, upon request and in accordance with the legislation;</li>
                    <li>To offer various opportunities to our members in a broad scope or to share these opportunities with persons or institutions within the legal framework;</li>
                    <li>To analyze advertising preferences,</li>
                </ul>
                <p>It will be processed in accordance with KVKK No. 6698 and relevant secondary regulations.</p>
            </section>

            <section className="space-y-4">
                <h2 className="text-xl font-bold text-foreground border-l-4 border-primary pl-4 uppercase tracking-wider">3. Information About Third Parties or Organizations to Which Your Personal Data May Be Transferred</h2>
                <p>
                    For the purposes stated above, the persons / organizations to whom your personal data shared with profinoks.com, profinoks.com.tr, profinoks.net can be transferred; our main shareholders, shareholders, advertisers, direct or indirect domestic / foreign affiliates; persons and organizations related to the service provided, in short, program partner organizations, domestic / foreign organizations and other 3rd persons and organizations that we receive services from, cooperate with, or act as Data Processors to carry out our activities.
                </p>
            </section>

            <section className="space-y-4 text-sm bg-gray-50 p-6 rounded-lg border border-black/5">
                <h2 className="text-lg font-bold text-foreground uppercase tracking-wider">4. Contact and Application Method</h2>
                <p>
                    Personal Data Owners can direct their questions, opinions or requests to the <a href="mailto:info@profinoks.com.tr" className="text-primary hover:underline">info@profinoks.com.tr</a> e-mail address.
                </p>
            </section>
        </div>
    );

    return (
        <div className="mt-[122px] md:pt-[130px] lg:pt-[140px] bg-background pb-20 text-foreground min-h-screen">
            <div className="mx-auto max-w-4xl px-4 py-12">
                <header className="mb-12 border-b border-black/10 pb-8">
                    <h1 className="text-3xl md:text-4xl font-semibold tracking-tight uppercase text-primary">
                        {t(lang, "legal.privacyTitle")}
                    </h1>
                    <p className="mt-4 text-muted-foreground text-sm">
                        {t(lang, "legal.lastUpdate")}: 17 / 02 / 2026
                    </p>
                </header>

                {lang === "tr" ? <ContentTR /> : <ContentEN />}

                <section className="text-xs text-muted-foreground border-t border-black/5 pt-8 mt-8 italic">
                    <p>
                        Web sayfamızda, uygulamalarımızda ve diğer sair kanallarımızda kişisel verilerinizi paylaşarak Kişisel Veriler Politikamızı ve politikamızda yer alan işlenme, işlenme yöntemleri, verilerin aktarılması, satışı ve diğer ilgili hususlar hakkındaki şartları kabul etmiş olursunuz.
                    </p>
                </section>
            </div>
        </div>
    );
};

export default PrivacyPage;
